/* eslint-disable react/jsx-no-bind */
import React, { useState } from 'react';
import Markdown from 'markdown-to-jsx';
import cn from 'classnames';
import { Button } from 'ui';
import { ButtonVariants } from 'ui/primitives';
import s from './Jumbo.module.scss';

interface JumboPropTypes {
  jumbo: string;
  clsname?: string;
  isDesktop?: boolean;
  maxHeight?:number;
}

export const Jumbo: React.FunctionComponent<JumboPropTypes> = ({
  jumbo,
  clsname,
  isDesktop = false,
  maxHeight=160,
}) => {
  const showViewMore = jumbo?.length > 350;
  const [isViewMore, setIsViewMore] = useState<boolean>(showViewMore);
  function handleClick() {
    setIsViewMore((state) => !state);
  }

  return (
    <div className={s.root}>
      <div
        className={cn(s.content, {
          [s.hide]: isViewMore,
          [s.show]: !isViewMore,
          [s.desktop_hide]: isDesktop,
        })}
        style={{maxHeight: isViewMore ? maxHeight : 'fit-content'}}
      >
        <Markdown>{jumbo}</Markdown>
        {isViewMore && (
          <div
            className={cn(s.opacity_box, clsname, {
              [s.desktop_opacity]: isDesktop,
            })}
          />
        )}
      </div>
      {showViewMore && (
        <div className={s.btn}>
          <Button
            label={`${isViewMore ? 'Read more' : 'Collapse'}`}
            variant={ButtonVariants.PrimaryNaked}
            onClick={handleClick}
          />
        </div>
      )}
    </div>
  );
};
